<template>
  <v-snackbar v-if="pending" :value="true" top :timeout="-1" class="recording-recovery-banner">
    <div class="d-flex align-center">
      <v-icon color="orange darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
      <span>
        Encontramos uma gravação não enviada da sessão de
        <strong>{{ pending.customerName || 'um paciente' }}</strong>.
      </span>
    </div>
    <template v-slot:action>
      <app-btn small text color="primary" @click="recover">Recuperar</app-btn>
      <v-btn icon small @click="dismiss">
        <v-icon small>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import RecordingStorage from "@/api/RecordingStorage";

export default {
  data() {
    return {
      pending: null,
    };
  },

  async created() {
    try {
      const all = await RecordingStorage.getAllMeta();
      if (all.length) {
        this.pending = all.sort((a, b) => b.updatedAt - a.updatedAt)[0];
      }
    } catch (err) {
      console.error('Falha ao verificar gravações pendentes:', err);
    }
  },

  methods: {
    recover() {
      const sessionId = this.pending.session_id;
      this.pending = null;
      this.$store.dispatch('recorder/setPendingReopen', sessionId);
    },

    dismiss() {
      this.pending = null;
    },
  },
};
</script>

<style scoped>
.recording-recovery-banner {
  z-index: 250;
}
</style>
